import { Chart } from './Chart.js'

class DonutChart extends Chart {
  type = 'donut'

  constructor() {
    super()
  }

  options = {
    ...this.options,
    chart: {
      ...this.options.chart
    },
    colors: ['#5b21b6', '#fbca28', '#f15bb5', '#06b6d4'],
    labels: [],
    legend: {
      position: 'bottom'
    },
    plotOptions: {
      customScale: 1.5
    },
    dataLabels: {
      style: {
        fontSize: '10px',
        colors: ['#fff']
      },
      dropShadow: {
        enabled: false
      }
    }
  }

  series = [10, 3]

  setLabels(labels: any[]): void {
    this.options = {
      ...this.options,
      labels: labels
    }
  }
}

export { DonutChart }
